import { useState } from "react";
import { Mail, Send } from "lucide-react";
import { toast } from "sonner";
import { adminClient } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export default function TestEmailDialog({ open, onOpenChange }) {
  const [email, setEmail] = useState(() => localStorage.getItem("sandlab_test_email") || "");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);
    try {
      const { data } = await adminClient.post("/admin/test-email", { email });
      localStorage.setItem("sandlab_test_email", email);
      setResult(data);
      if (data.success) toast.success(`Το δοκιμαστικό email στάλθηκε στο ${email}`);
      else toast.error("Η αποστολή απέτυχε");
    } catch (err) {
      toast.error(err.response?.data?.detail?.[0]?.msg || err.response?.data?.detail || "Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="test-email-dialog" className="sm:max-w-md rounded-3xl">
        <DialogHeader>
          <div className="mx-auto h-14 w-14 rounded-full bg-sunset/15 flex items-center justify-center mb-2">
            <Mail className="h-7 w-7 text-sunset" />
          </div>
          <DialogTitle className="text-center text-2xl font-heading font-black">Δοκιμαστικό email</DialogTitle>
          <DialogDescription className="text-center">
            Στείλε ένα email με το πρότυπο της ακαδημίας (logo, χρώματα, κουμπί) για να δεις πώς φαίνεται.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <div>
            <Label className="text-xs font-semibold uppercase tracking-widest text-slate-500">Αποστολή στο</Label>
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="test-email-input"
              className="mt-1.5 h-11 rounded-2xl"
              placeholder="you@example.com"
            />
          </div>
          {result && (
            <div
              data-testid="test-email-result"
              className={`rounded-2xl px-4 py-3 text-sm ${
                result.success ? "bg-emerald-50 text-emerald-800" : "bg-red-50 text-red-700"
              }`}
            >
              {result.success
                ? `Στάλθηκε επιτυχώς (${result.provider}). Έλεγξε τα εισερχόμενα/spam.`
                : `Αποτυχία (${result.provider}): ${result.error}`}
            </div>
          )}
          <Button
            type="submit"
            disabled={loading}
            data-testid="test-email-submit"
            className="w-full h-11 rounded-full bg-sunset hover:bg-sunset-hover text-white font-bold"
          >
            <Send className="h-4 w-4 mr-2" /> {loading ? "Αποστολή…" : "Στείλε δοκιμαστικό email"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
